import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import { formatDateTimeSSFromApi } from "../utils/dateTime";
import { getBotState } from "../utils/botUtils";

@inject("store")
@observer
export default class BotState extends Component {
  render() {
    const {
      store: { zoneId },
      botInstance: bi,
    } = this.props;

    const state = getBotState(bi);
    const stateToDisplay = { ...state };
    delete stateToDisplay.tradeList;
    delete stateToDisplay.closedTradeList;

    return (
      <div>
        <b>Started: {formatDateTimeSSFromApi(bi.startedAt, zoneId)}</b>
        , Finished: {formatDateTimeSSFromApi(bi.finishedAt, zoneId)}
        {bi.nextRunAt && ", Next Run: " + formatDateTimeSSFromApi(bi.nextRunAt, zoneId)}
        <pre>{JSON.stringify(stateToDisplay, null, 4)}</pre>
        {bi.tickError && <pre style={{ color: "red" }}>{bi.tickError}</pre>}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/bot/BotState.js